<template>
  <NavigationButton
    action="close"
    icon="/icons/close.svg"
    :theme="theme"
  >
  </NavigationButton>
</template>

<script>

  import NavigationButton from "@/components/buttons/navigation/NavigationButton";

  export default {
    name: 'CloseButton',
    components: {NavigationButton},
    props: ['theme'],
    data() {
      return {
      }
    },
    methods: {

    },

    created() {
    }
  }
</script>

<style>


</style>
